import { InjectionToken, inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { environment } from '../../../environments/environment';

/**
 * The only route rows the sidebar lists (`environment.navOnlyPaths`), or null for the full menu.
 * Set only in the develop build for a module demo: it trims the menu, it does not guard routes.
 */
export const NAV_ONLY_PATHS = new InjectionToken<readonly string[] | null>('NAV_ONLY_PATHS', {
  providedIn: 'root',
  factory: () => {
    const paths: readonly string[] | null | undefined = environment.navOnlyPaths;
    return paths && paths.length > 0 ? paths : null;
  },
});

/** Inicio is not in a trimmed menu: it sends the user to the first allowed screen instead. */
export const navOnlyPathsHomeGuard: CanActivateFn = () => {
  const onlyPaths = inject(NAV_ONLY_PATHS);
  return onlyPaths === null ? true : inject(Router).parseUrl(onlyPaths[0]);
};
